var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconSidebarFiles(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 23,
    viewBox: "0 0 22 23",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_845_16892)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M14.4375 19.8042H4.8125C4.63016 19.8042 4.4553 19.7318 4.32636 19.6028C4.19743 19.4739 4.125 19.299 4.125 19.1167V6.7417C4.125 6.55936 4.19743 6.38449 4.32636 6.25556C4.4553 6.12663 4.63016 6.0542 4.8125 6.0542H11.6875L15.125 9.4917V19.1167C15.125 19.299 15.0526 19.4739 14.9236 19.6028C14.7947 19.7318 14.6198 19.8042 14.4375 19.8042Z",
    stroke: "#EEEFFF",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.875 6.0542V3.9917C6.875 3.80936 6.94743 3.63449 7.07636 3.50556C7.2053 3.37663 7.38016 3.3042 7.5625 3.3042H14.4375L17.875 6.7417V16.3667C17.875 16.549 17.8026 16.7239 17.6736 16.8528C17.5447 16.9818 17.3698 17.0542 17.1875 17.0542H15.125",
    stroke: "#EEEFFF",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.5625 13.6167H11.6875",
    stroke: "#EEEFFF",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.5625 16.3667H11.6875",
    stroke: "#EEEFFF",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_845_16892"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 22,
    height: 22,
    fill: "white",
    transform: "translate(0 0.554199)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconSidebarFiles);
export default __webpack_public_path__ + "static/media/icon-sidebar-files.4190d705e52f6e6b1adf75f2a2b4537b.svg";
export { ForwardRef as ReactComponent };